// extracted by mini-css-extract-plugin
export default {"root":"EntityPageHeaderLayout_root__VOGpf","left":"EntityPageHeaderLayout_left__LHspV","center":"EntityPageHeaderLayout_center__Sr1Kq","right":"EntityPageHeaderLayout_right__8ThYy"};